// Swym読み込み後に実行。お気に入りは独自ハート(.favorite_button)で操作する。
//  - 追加: getProductDetails({du})で商品を認識させてから addToWishList。
//          未認識(sw-unknown-product)の間は再プライミング+リトライで吸収する。
//  - 削除: 既にリスト内=認識済みのため deleteFromList。
//  - 点灯は楽観的に即時反映。成功後の fetchLists 照合は遅延させる(反映ラグで一瞬消えるのを防ぐ)。
// 点灯クラス: 商品詳細=.atw-button-added / 一覧・検索=.in

function onSwymLoadCallback(swat) {
	if (!swat) return null;

	var ADDED_CLASSES = ['in', 'atw-button-added'];
	var MAX_ADD_ATTEMPTS = 5;
	var RECONCILE_DELAY = 4000;
	var list_id = null;
	var wishlistedVariantIds = new Set();
	var inFlight = new Set(); // 処理中のバリアント(二重操作防止・楽観表示の保護)
	var reconcileTimer = null;

	function setButtonState(button, added) {
		ADDED_CLASSES.forEach(function (cls) { button.classList.toggle(cls, added); });
	}
	function setVariantHearts(id, added) {
		document.querySelectorAll('.favorite_button[data-variant="' + id + '"]').forEach(function (b) {
			setButtonState(b, added);
		});
	}
	function applyMarks() {
		document.querySelectorAll('.favorite_button').forEach(function (button) {
			var id = button.dataset.variant;
			if (id && inFlight.has(String(id))) return; // 処理中の楽観表示は保護
			setButtonState(button, !!id && wishlistedVariantIds.has(String(id)));
		});
	}
	function fetchAndApply() {
		swat.fetchLists({
			callbackFn: function (lists) {
				wishlistedVariantIds = new Set();
				list_id = (lists && lists[0]) ? lists[0].lid : null;
				(lists || []).forEach(function (l) {
					((l && l.listcontents) || []).forEach(function (c) {
						wishlistedVariantIds.add(String(c.epi));
					});
				});
				applyMarks();
			},
			errorFn: function (error) { console.log('[wishlist] fetchLists error', error); }
		});
	}
	function scheduleReconcile() {
		if (reconcileTimer) clearTimeout(reconcileTimer);
		reconcileTimer = setTimeout(function () { reconcileTimer = null; fetchAndApply(); }, RECONCILE_DELAY);
	}

	fetchAndApply();

	// バリアント単位でプライミングする。du にバリアント指定が無いとデフォルトバリアントしか
	// 認識されず、他バリアント(状態/発送方法違い)が sw-unknown-product になるため ?variant= を付ける。
	function primeProduct(du, epi) {
		if (du && typeof swat.getProductDetails === 'function') {
			var url = du + (du.indexOf('?') >= 0 ? '&' : '?') + 'variant=' + epi;
			try { swat.getProductDetails({ du: url }); } catch (e) { /* noop */ }
		}
	}

	function addWithRetry(product, id, attempt) {
		swat.addToWishList(product, function () {
			wishlistedVariantIds.add(id);
			inFlight.delete(id);
			setVariantHearts(id, true);
			scheduleReconcile();
		}, function (error) {
			// リトライは sw-unknown-product(プライミング未完了=回復見込みあり)のみ。
			// 500系(type:unknown-exception 等のSwymサーバー障害)は再試行しても直らないため即失敗扱い。
			var isUnknownProduct = !!error && (error.type === 'sw-unknown-product' || error.msg === 'Unknown product');
			if (isUnknownProduct && attempt < MAX_ADD_ATTEMPTS) {
				primeProduct(product.du, product.epi);
				setTimeout(function () { addWithRetry(product, id, attempt + 1); }, 500 + attempt * 600);
				return;
			}
			inFlight.delete(id);
			setVariantHearts(id, false);
			scheduleReconcile();
			alert('追加に失敗しました。');
			console.log('[wishlist] add error', error);
		});
	}

	document.addEventListener('click', function (event) {
		var button = event.target.closest && event.target.closest('.favorite_button');
		if (!button) return;
		var epi = button.dataset.variant;
		if (!epi) return;
		var id = String(epi);
		if (inFlight.has(id)) return;

		var product = {
			epi: Number(epi),                      // 数値で送る(文字列だと sw-unknown-product になる)
			empi: Number(button.dataset.product),
			du: button.dataset.product_url,
			source: 'pdp'
		};
		inFlight.add(id);

		if (!wishlistedVariantIds.has(id)) {
			setVariantHearts(id, true);
			primeProduct(product.du, product.epi);
			addWithRetry(product, id, 1);
		} else {
			setVariantHearts(id, false);
			if (!list_id) { inFlight.delete(id); scheduleReconcile(); return; }
			swat.deleteFromList(list_id, product, function () {
				wishlistedVariantIds.delete(id);
				inFlight.delete(id);
				scheduleReconcile();
			}, function (error) {
				inFlight.delete(id);
				setVariantHearts(id, true);
				scheduleReconcile();
				alert('削除に失敗しました。');
				console.log('[wishlist] delete error', error);
			});
		}
	});

	// 絞り込み・追加読み込みで後から差し込まれたハートにも点灯を反映
	var applyMarksScheduled = false;
	new MutationObserver(function () {
		if (applyMarksScheduled) return;
		applyMarksScheduled = true;
		setTimeout(function () { applyMarksScheduled = false; applyMarks(); }, 300);
	}).observe(document.body, { childList: true, subtree: true });
}

if (!window.SwymCallbacks) {
	window.SwymCallbacks = [];
}
window.SwymCallbacks.push(onSwymLoadCallback);
